import {Shift, ShiftDto} from '../types'

export const mapShifts = (shifts: ShiftDto[]): Shift[] =>
  shifts.map(
    (shift: ShiftDto): Shift => ({
      id: shift.id,
      start: shift.start,
      end: shift.end,
      weekDays: shift.weekDays,
      endTechnical: shift.endTechnical,
      name: shift.name
    })
  )
